const DB = "pg-offline", STORE = "responses", KEYS = "keys", SYNC_KEY = "pg_last_sync";
const bus = new EventTarget();
let online = typeof navigator === "undefined" ? true : navigator.onLine;

export const isOnline = () => online;
export const setOnline = (v) => { if (online === v) return; online = v; bus.dispatchEvent(new Event("change")); };
export const onOnlineChange = (fn) => { bus.addEventListener("change", fn); return () => bus.removeEventListener("change", fn); };
export const lastSync = () => Number(localStorage.getItem(SYNC_KEY) || 0);
export const markSync = () => { try { localStorage.setItem(SYNC_KEY, String(Date.now())); } catch {} };

if (typeof window !== "undefined") {
  window.addEventListener("online", () => setOnline(true));
  window.addEventListener("offline", () => setOnline(false));
}

let dbp = null;
const openDB = () => dbp || (dbp = new Promise((res, rej) => {
  const rq = indexedDB.open(DB, 1);
  rq.onupgradeneeded = () => { const d = rq.result; if (!d.objectStoreNames.contains(STORE)) d.createObjectStore(STORE); if (!d.objectStoreNames.contains(KEYS)) d.createObjectStore(KEYS); };
  rq.onsuccess = () => res(rq.result); rq.onerror = () => rej(rq.error);
}));
const tx = (store, mode, fn) => openDB().then((d) => new Promise((res, rej) => { const t = d.transaction(store, mode); const r = fn(t.objectStore(store)); t.oncomplete = () => res(r && r.result); t.onerror = () => rej(t.error); }));

let keyp = null;
const getKey = () => keyp || (keyp = (async () => {
  const existing = await tx(KEYS, "readonly", (s) => s.get("aes"));
  if (existing) return existing;
  const k = await crypto.subtle.generateKey({ name: "AES-GCM", length: 256 }, false, ["encrypt", "decrypt"]);
  await tx(KEYS, "readwrite", (s) => s.put(k, "aes"));
  return k;
})());

const enc = new TextEncoder(), dec = new TextDecoder();
export async function offlinePut(key, data) {
  try {
    const k = await getKey(); const iv = crypto.getRandomValues(new Uint8Array(12));
    const buf = await crypto.subtle.encrypt({ name: "AES-GCM", iv }, k, enc.encode(JSON.stringify(data)));
    await tx(STORE, "readwrite", (s) => s.put({ iv, buf, ts: Date.now() }, key));
  } catch {}
}
export async function offlineGet(key) {
  try {
    const rec = await tx(STORE, "readonly", (s) => s.get(key));
    if (!rec) return null;
    const k = await getKey();
    const plain = await crypto.subtle.decrypt({ name: "AES-GCM", iv: rec.iv }, k, rec.buf);
    return { data: JSON.parse(dec.decode(plain)), ts: rec.ts };
  } catch { return null; }
}
export const offlineClear = () => Promise.all([tx(STORE, "readwrite", (s) => s.clear()), tx(KEYS, "readwrite", (s) => s.clear())]).then(() => { keyp = null; localStorage.removeItem(SYNC_KEY); }).catch(() => {});
export const offlineError = () => { const e = new Error("offline"); e.offline = true; e.response = { status: 0, data: { detail: "You're offline — changes can't be saved until the connection returns." } }; return e; };
